export default {
  backendURL:
    process.env.NODE_ENV == 'development'
      ? 'http://localhost:5001/api'
      : 'https://chipcustomizerapp.com/api',
  secure: process.env.NODE_ENV == 'development' ? false : true,
  background: '#3A3A3A',
  background_dark_slight: '#2e2e2e',
  background_dark: '#212121',
  background_light: '#4B4B4B',
  dull: 'grey darken-2',
  alert: 'red lighten-1',
  cancel: 'red lighten-1',
  confirm: '#29AD00',
  xbackground: '#FAFAFA',
  xbackground_dark: '#EEEEEE',
  xbackground_light: '#FFFFFF',
  dark_background: true,
  theme: 'white',
  dark: true,
  dark_primary: true,
  dark_secondary: true,
  primary: '#B71C1C',
  secondary: '#424242',
  primary_text: 'white',
  secondary_text: 'white',
  footer: '#292929',
  dark_footer: true,
  special_1: '#FF9600',
  special_2: '#07C700',
}
